import classNames from "classnames";
import { Immutable } from "immer";
import React, { useState } from "react";
import SVG from "react-inlinesvg";

import iconQuestionMarkCircleTeal from "../../../../img/icons/question-mark-circle--teal.svg";
import { PLCInfoPanel } from "../PLCInfoPanel";
import { PLCProductCategorySelectorOption } from "../PLCProductCategorySelectorOption";
import { IPLCOptionPanel, IPLCProductCategorySelector } from "../models";

// Load styles
import "./index.scss";

type IProps = Immutable<{
    categorySelectors: readonly IPLCProductCategorySelector[];
    optionPanels: readonly IPLCOptionPanel[];
    selector: IPLCProductCategorySelector;
}>;

const BEM_NAME = "plc-configurator-category-selector";

export function PLCProductCategorySelector(props: IProps): React.ReactNode {
    const [isSelected, setIsSelected] = useState(false);

    const handleOptionSelected = (): void => {
        setIsSelected(true);
    };

    const selectorClasses = classNames({
        [`${BEM_NAME}`]: true,
        [`${BEM_NAME}--selected`]: isSelected,
    });

    return (
        <fieldset className={selectorClasses}>
            <legend>
                {props.selector.value.name}
                &nbsp;
                <PLCInfoPanel
                    buttonText={
                        <sup>
                            <SVG
                                aria-hidden="true"
                                src={iconQuestionMarkCircleTeal}
                            />
                        </sup>
                    }
                    content={props.selector.value.learn_more}
                />
            </legend>
            <ul>
                {props.selector.value.options.map((option) => (
                    <PLCProductCategorySelectorOption
                        key={`${option.category.id}`}
                        categorySelectors={props.categorySelectors}
                        optionPanels={props.optionPanels}
                        selectorID={props.selector.id}
                        option={option}
                        onOptionSelected={handleOptionSelected}
                    />
                ))}
            </ul>
        </fieldset>
    );
}
